<!-- 神回复子项 -->
<template>
<div class="god-reply-item">
    <div class="user-avator">
        <YorkbbsImage
            v-if="avatar"
            class="post-cover"
            :src="avatar | webpFormat(200)"
            :link="homeURL"
            borderRadius="50%"
            target="_blank"
            :title="title"
            width='100%'
            height="100%"
            animation
            />
    </div>
    <div class="post-cont">
        <div class="user-name">{{username}}</div>
        <div class="content" ><a :href="topicDetailURL+'&floor='+post.floor|hostBuild('forum')" v-html="replyContent" target="_blank"></a></div>
        <div class="img-cont" v-if="imageList.length>0">
            <template v-for="(item,index) in imageList">
                <div class="ig" :key="item+'_'+index" v-if="index<9">
                    <YorkbbsImage
                       
                        class="post-cover"
                        :src="item | webpFormat(200)"
                        :href="topicDetailURL+'&floor='+post.floor|hostBuild('forum')"
                        borderRadius="4px"
                        target="_blank"
                        :aspect="true"
                        animation
                        />
                </div> 
            </template>
        </div>
        <div class="topic-info">
            <a :href="topicDetailURL|hostBuild('forum')" target="_blank">
                <template v-if="post.postInfo.imageList.length>0">
                    <YorkbbsImage
                        
                        class="post-cover"
                        :src="post.postInfo.imageList[0] | webpFormat(200)"
                        
                        borderRadius="4px"
                        target="_blank"
                        :title="topicTitle"
                        
                        animation
                    />
                </template>
                <template v-else>
                    <div class="default-cover"><img :src="require('./assets/god-reply-default-topic.png')" alt=""></div>
                </template>
                <div class="title">{{topicTitle}}</div>
            </a>
        </div>
        <div class="desc-info">
            <div class="time">{{createdAt|timeToStr}}</div>
            <div class="fn-cont comment-msg">
                <a :href="topicDetailURL+'&floor='+post.floor|hostBuild('forum')" target="_blank">
                    <i class="yk-information"></i>{{commentTotal}}
                </a>
                
            </div>
            <div class="fn-cont thumbUp" :class="{clicked:hasThumbUp}" @click="thumbUp">
                <i class=" " :class="{'yk-liked':hasThumbUp,'yk-like':!hasThumbUp}"></i>{{thumbUpTotal?thumbUpTotal:'点赞'}}
            </div>
        </div>
    </div>
    
</div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
    name:'GodReplyItem',
    props:['post'],
    data(){
        return {

        }
    },
    computed:{
        // 用户头像
        avatar() {
            return this.post.user ? this.post.user.avatar : '';
        },
        // 用户名
        username() {
            return this.post.user ? this.post.user.username : '';
        },
         // 用户中心
        homeURL() {
            return this.post.user ? hostBuild(`/home/${this.post.user.id}`, 'home') : '/';
        },
        // 标题
        title() {
            return this.post.title;
        },
        replyContent(){
            return this.post.contentText;
        },
        imageList(){
            return this.post.imageList;
        },
        topicTitle(){
            return this.post.postInfo.title|| '';
        },
        createdAt(){
            return this.post.createdAt;
        },
        commentTotal(){
            return this.post.property.commentTotal;
        },
        thumbUpTotal(){
            return this.post.property.thumbUpTotal||0;
        },
        hasThumbUp(){
            return this.post.property.hasGivenThumbUp;
        },
        account(){
            return this.$store.getters.user;
        },
        topicDetailURL() {
            return `/detail/${this.post.postInfo.id}?topic=${this.post.postInfo.topicEngName}`;
        },
    },
    methods:{
        async thumbUp(){
            
            if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if( this.postLoading ) return false;
            if( !this.hasThumbUp ){
                this.postLoading = true;
                let result = await this.$axios.post('/bbs/v1/give/thumb/up/to/comment',{ownerId:this.post.id});
                this.postLoading = false;
                if( result.code == 0 ){
                    this.$success('点赞成功!');
                    this.post.property.hasGivenThumbUp = 1;
                    this.post.property.thumbUpTotal +=1;
                }
                
            }else{
                this.postLoading = true;
                let result = await this.$axios.post('/bbs/v1/drop/thumb/up/from/comment',{ownerId:this.post.id});
                this.postLoading = false;
                if( result.code == 0 ){
                    this.$success('取消点赞成功!');
                    this.post.property.hasGivenThumbUp = 0;
                    this.post.property.thumbUpTotal -=1;
                }
               
            }
        }
    }
}
</script>
<style lang="less" scoped>
.god-reply-item{
    display: flex; padding: 15px; border-radius: 10px; background: #fff; margin:20px 15px;
    .user-avator{width:34px; height: 34px; border-radius: 50%; border:1px solid #eee}
    .post-cont{
        margin-left: 10px; flex: 1;
        .user-name{font-size: 16px; line-height: 34px;margin-bottom:5px;color: #406599;
            a{color: #406599;}
        }
        .content{font-size: 16px;  line-height: 30px; color: #111; margin-bottom: 10px;
            max-height: 90px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
        }
        .img-cont{
            margin: 0 -2px; display: flex;  padding-bottom: 5px;
            .ig{
                width: 33.33%; padding: 0 2px; margin-bottom: 4px; box-sizing: border-box;
            }
        }
        .topic-info{
            display: flex; align-items: center; box-sizing: border-box;margin-bottom:15px;
            a{
                display: flex; background: #f8f8f8; padding: 5px 10px 5px 5px; border-radius: 4px; align-items: center;
                .title{font-size: 14px; line-height: 18px; color: #666; flex:1;overflow: hidden;}
                .post-cover{margin-right: 6px; width: 40px; height: 40px;}
                .default-cover{display: flex; align-items: center; padding-left: 7px; margin-right: 6px;}
            }
        }
        .desc-info{
            display: flex; align-items: center;
            .time{flex:1; color: #999; font-size: 14px;}
            .fn-cont{
                display: flex; align-items: center; font-size: 14px; margin-left: 40px;
                i{margin-right: 5px;}
                /* &.comment-msg{
                    i{transform: rotateY(180deg);}
                } */
                &.thumbUp{
                    user-select: none; cursor: pointer;
                    i{font-size: 22px;}
                    &.clicked{color: #e43a3a;
                        i{transform-origin: center; animation-name: scaleUpBack; animation-duration: 500ms; animation-timing-function: linear;}
                    }
                }
                &:hover{color: #e43a3a;}
            }
        }
    }
}
@keyframes scaleUpBack{
    0%{transform: scale(1);}
    50%{transform: scale(1.2);}
    100%{transform: scale(1);}
}
@media screen and (min-width:768px) {
    .god-reply-item{
        width:800px; margin: 20px auto; padding: 30px; border-radius: 20px;
        .user-avator{width:34px; height:34px}
        .post-cont{
            .user-name{font-size: 16px; line-height: 34px;}
            .img-cont{
                margin: 0 -5px;
                .ig{width:20%; padding: 0 5px; margin-bottom: 10px;}
            }
        }
    }
}
</style>